<template>
  <div class="seg-item" :class="{'seg-origin': seg.isOrigin}">
    <div class="seg-col seg-ct-col"  v-if="seg.tripType === 'CT'">
      <span>{{ seg.segIndex + 1 }} 程</span>
    </div>
    <div class="seg-col seg-action-col" v-if="selectAble">
      <a-checkbox
        :disabled="segCheckDisable"
        :checked="seg.checked"
        @change="onChange($event, seg)"></a-checkbox>
    </div>
    <div class="seg-col">
      <div class="seg-info">
        <segment-Info
          :seg="seg"
          :order="order"
          v-bind="$attrs"
        ></segment-Info>
        <extend-info
          v-if="seg.ancillaries.length"
          :seg="seg"
          :order="order"
          v-bind="$attrs"
          v-on="$listeners"
        ></extend-info>
      </div>
    </div>
  </div>
</template>

<script>
import SegmentInfo from './SegmentInfo'
import ExtendInfo from './ExtendInfo'

export default {
  name: 'SegmentBox',
  props: {
    order: {
      type: Object,
      default: function () {
        return {}
      }
    },
    passenger: {
      type: Object,
      default: function () {
        return {}
      }
    },
    seg: {
      type: Object,
      default: function () {
        return {}
      }
    },
    selectAble: {
      type: Boolean,
      default: function () {
        return true
      }
    }
  },
  computed: {
    segCheckDisable: function () {
      const { ticketStatus, status } = this.seg
      return ticketStatus ? ticketStatus !== 'OPEN_FOR_USE' : ['RR', 'HK', 'HL'].indexOf(status) < 0
    }
  },
  methods: {
    onChange: function (e, seg) {
      this.$emit('seg-change', e, seg)
    }
  },
  components: {
    SegmentInfo,
    ExtendInfo
  }
}
</script>
